import { createContext, useContext, useId } from 'react';

export interface FieldContextValue {
  id: string;
  invalid: boolean;
  describedBy?: string;
}

export const FieldContext = createContext<FieldContextValue | null>(null);

export function useFieldContext() {
  return useContext(FieldContext);
}

export function useFieldIds(hasError: boolean) {
  const id = useId();
  const errorId = `${id}-message`;
  const ctx: FieldContextValue = { id, invalid: hasError, describedBy: hasError ? errorId : undefined };
  return { id, errorId, ctx };
}
